<template>
  <v-card>
    <v-card-title>
      Dodaj nową firmę
    </v-card-title>
    <v-card-text>
      <CompanyAddEdit
          :nipHint="nipHint"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import CompanyAddEdit from "@/components/price-list/CompanyAddEdit";

export default {
  components: {
    CompanyAddEdit,
  },
  data() {
    return {
      nipHint:
          'System spróbuje automatycznie podpiąć potwierdzoną firmę z głównej tabeli, ' +
          'która ma taki sam NIP, o ile istnieje dokładnie jedno takie dopasowanie.',
    }
  },
}
</script>